import ActivityDialog from './ActivityDialog';

export default ActivityDialog;
